import { Link, useLocation } from "react-router-dom";

const AccountSidebar = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path ? "active" : "";

  return (
    <div className="col-md-3">
      <div className="vertical_menu">
        <ul>
          <li>
            <Link to="/order" className={isActive("/order")}>
              <i className="fas fa-shopping-cart"></i> My Order
            </Link>
          </li>

          <li>
            <Link to="/user-profile" className={isActive("/user-profile")}>
              <i className="fa fa-user"></i> Profile
            </Link>
          </li>

          <li>
            <Link to="/my-address" className={isActive("/my-address")}>
              <i className="fas fa-users"></i> Manage address
            </Link>
          </li>

          <li>
            <Link to="/wishlist" className={isActive("/wishlist")}>
              <i className="fas fa-chart-line"></i> Wishlist
            </Link>
          </li>

          <li>
            <Link to="/compare" className={isActive("/compare")}>
              <i className="far fa-comments"></i> Compare
            </Link>
          </li>

          <li>
            <Link to="/user-delete" className={isActive("/user-delete")}>
              <i className="far fa-comments"></i> Delete Account
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AccountSidebar;